import RequestAbstract from "../abstract";

export default class Wallets extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/wallets";
    }
    assignPayoutAccount(data) {
        return this.loadWithAuth(this.link + "/assign-payout-account", {
            method: "POST",
            body: JSON.stringify(data),
        });
    }
}
